type KukaiLoginInfo = {
  pkh: string;
  pk: string;
};

type KukaiEmbedLike = {
  initialized: boolean;
  user: KukaiLoginInfo | null;
  init: () => Promise<unknown>;
  login: (config?: unknown) => Promise<KukaiLoginInfo>;
  send: (operations: Array<Record<string, unknown>>) => Promise<string>;
  signExpr: (expr: string, ui?: unknown) => Promise<string>;
  logout: () => Promise<void>;
};

let kukaiEmbedInstance: KukaiEmbedLike | null = null;

export async function getKukaiEmbed(): Promise<KukaiEmbedLike> {
  if (kukaiEmbedInstance) {
    if (!kukaiEmbedInstance.initialized) {
      await kukaiEmbedInstance.init();
    }
    return kukaiEmbedInstance;
  }
  const kukai = await import("kukai-embed");
  const net =
    window.location.hostname === "localhost"
      ? kukai.Networks.ghostnet
      : kukai.Networks.mainnet;
  const embed = new kukai.KukaiEmbed({
    net,
    icon: false,
    autoSync: true,
  }) as unknown as KukaiEmbedLike;
  await embed.init();
  kukaiEmbedInstance = embed;
  return embed;
}

export async function ensureKukaiLogin(): Promise<KukaiLoginInfo> {
  const embed = await getKukaiEmbed();
  if (embed.user?.pkh && embed.user?.pk) {
    return embed.user;
  }
  return embed.login();
}

export async function logoutKukaiEmbed(): Promise<void> {
  if (!kukaiEmbedInstance) {
    return;
  }
  await kukaiEmbedInstance.logout().catch(() => {
    // Ignore widget logout failures.
  });
}
